export const ROUTE_LAYOUT = [
  '/',
  '/profile',
  '/course/[slug]',
  '/course/[slug]/discussion',
  '/course/[slug]/course-workshop',
  '/course/[slug]/course-ws-create',
  '/course/[slug]/course-ws-view',
  '/course/[slug]/course-ws-edit',
  '/course/[slug]/discussion/[id]',
  '/course/[slug]/[type]',
  '/course/[slug]/newAssignment',
  '/course/[slug]/add-test',
  '/course/[slug]/DetailTest',
  '/course/[slug]/edit-test',
  '/course/[slug]/add-survey',
  '/course/[slug]/edit-survey',
  '/course/[slug]/users-and-progress',
  '/course/[slug]/files',
  '/course/[slug]/rules-and-path',
  '/course/[slug]/great-book',
  '/course/[slug]/report',
  '/course/[slug]/add-classroom/[unitId]',
  '/course/[slug]/add-classroom/[unitId]/Addclassroom',
  '/course/[slug]/add-classroom/[unitId]/users',
  '/course/[slug]/add-live-training',
  '/course/[slug]/add-live-training/liveClassNew',
  '/course/[slug]/add-live-training/[unitId]',
  '/course/[slug]/add-live-training/[unitId]/Addlivetraining',
  '/course/[slug]/add-live-training/[unitId]/users',
  '/calendar',
  '/course/create',
  '/course/[slug]/edit',
  '/unit/[id]/edit',
  '/course/[slug]/question/create',
  '/course/[slug]/question/edit',
  '/users',
  '/users/create',
  '/users/edit',
  '/course',
  '/category',
  '/category/create',
  '/category/[id]/edit',
  '/user-types',
  '/user-types/create',
  '/user-types/[id]/edit',
  '/group',
  '/group/create',
  '/group/[id]/edit',
  '/users/[id]/edit',
  '/course/[slug]/submissions/[id]',
  '/course/[slug]/submissions/assignment',
  '/import-export',
  '/reports',
  '/reports/users',
  '/reports/users/[id]',
  '/reports/courses',
  '/reports/courses/[slug]',
  '/reports/courses/DetailClassReport',
  '/reports/tests',
  '/reports/tests/questions',
  '/reports/tests/questions/[questionId]',
  '/reports/tests/[id]',
  '/reports/liveClass',
  '/reports/liveClass/[id]',
  '/reports/calandar',
  '/reports/attendance',
  '/reports/attendance/[id]',
  '/reports/assignments',
  '/reports/assignments/[id]',
  '/reports/surveys',
  '/reports/surveys/[id]',
  '/reports/surveys/questions',
  '/reports/surveys/questions/[questionId]',
  '/reports/scorm',
  '/reports/scorm/[id]',
  '/reports/demeritPoints/demeritGlobal',
  '/reports/demeritPoints/detailDemeritUser',
  '/reports/demeritPoints',
  '/reports/credits',
  '/reports/credits/creditsGlobal',
  '/reports/credits/creditsGlobalList',
  '/reports/credits/creditsHistoryList',
  '/reports/learning-path',
  '/reports/learning-path/[learningPathId]',
  '/reports/staffType',
  '/reports/staffType/[id]',
  '/reports/great-book/intake-report',
  '/reports/great-book/global-report',
  '/reports/competency',
  '/reports/competency/[userId]',
  '/users/[id]/[type]',
  '/intakes',
  '/intakes/intake-grid',
  '/intakes/create',
  '/intakes/[slug]',
  '/location',
  '/zoom',
  '/setting-account',
  '/account-settings',
  '/messages',
  '/notification',
  '/notification/[id]/edit',
  '/notification/create',
  '/notification/history',
  '/live-sessions',
  '/system-log',
  '/workshop',
  '/workshop/create',
  '/workshop/view',
  '/workshop/edit',
  '/workshop/workshopCard',
  '/announcement',
  '/announcement/view',
  '/announcement/create',
  '/business-rules',
  '/business-rules/[businessRuleId]',
  '/manage-staff-request',
  '/manage-staff-request/[manageStaffRequestId]',
  '/manage-staff-request/[manageStaffRequestId]/view',
  '/staff-request',
  '/staff-request/[staffRequestId]',
  '/staff-request/[staffRequestId]/edit',
  '/staff-request/[staffRequestId]/view',
  '/learning-path',
  '/learning-path/[learningPathId]',
  '/learning-path/userEnrollPage',
  '/reminder',
  '/reminder/create',
  '/homes/myLearning',
  '/homes/addCoupon',
  '/lms-user/cart',
  '/homes/cart/paymentsuccess',
  '/lms-user/home',
  '/lms-user/cart/wishList',
  '/lms-user/cmsBlog',
  '/lms-user/cmsBlog/testimonial',
  '/lms-user/cmsBlog/edit',
  '/lms-user/cmsBlog/view',
  '/course/newContentCourse',
  '/lms-user/cart/checkout',
  '/lms-user/instructor',
  '/intakes/intakeGrid',
  '/course/courseGrid',
  '/course/[slug]/whiteboard',
  '/course/[slug]/whiteboard/create',
  '/course/[slug]/unit/[unitId]',
  '/centre',
  '/centre/addcentre',
  '/centre/addcentres',
  '/timesheet/schedule',
  '/timesheet/schedule/addschedule',
  '/timesheet/schedule/view',
  '/timesheet/schedule/editschedule',
  '/timesheet/schedule/calenderview',
  '/centre/editCentre',
  '/timesheet/approve',
  '/timesheet/mytimesheet',
  '/timesheet/managetimesheet',
  '/timesheet/managetimesheet/edit',
  '/timesheet/managetimesheet/view',
  '/timesheet/mytimesheet/view',
  '/timesheet/mytimesheet/addbank',
  '/timesheet/approve/view',
  '/timesheet/approve/edit',
  '/timesheet/myschedule',
  '/timesheet/myschedule/view',
  '/timesheet/addtimesheet',
  '/timesheet/addtimesheet/view',
  '/manageCmsBlog',
  '/lms-user/footer',
  '/lms-user/getstarted',
  '/monitoring',
  '/homes/purchaseHistory/invoice',
  '/homes/purchaseHistory',
  '/homes/addCoupon/editCoupon',
  '/monitoring/liveClass',
  '/monitoring/liveTrack',
  '/Badge',
  '/Badge/create',
  '/Badge/badge',
  '/Badge/create/addType',
  '/Badge/modalBadges',
  '/certificate',
  '/certificate/template-create',
  '/certificate/template-create/[id]/generateCertificate',
  '/certificate/certificateReport',
  '/course/[slug]/certificate',
  '/certificate/userCertificate',
  '/certificate/userCertificate/[displayCertificate]',
  '/certificate/template-create/create',
  '/master/businessType/create',
  '/master/businessType',
  '/master/centreType',
  '/master/centreType/create',
  '/master/organization/create',
  '/master/organization',
  '/master/centres/create',
  '/master/centres',
  '/master/contentApproval',
  '/master/contentApproval/view',
  '/master/points',
  '/master/points/create',
  '/master/demerit',
  '/master/demerit/create',
  '/master/demeritType',
  '/master/demeritType/create',
  '/master/staffType',
  '/master/staffType/create',
  '/master/manageStaffType',
  '/master/manageStaffType/create',
  '/master/resource',
  '/master/resource/[resourceId]',
  '/master/location',
  '/master/location/[locationId]',
  '/master/core-competencies',
  '/master/core-competencies/[coreCompetencyId]',
  '/master/competency-mastery-levels',
  '/master/competency-mastery-levels/[masterLevelId]',
  '/master/competency-level',
  '/master/competency-level/[competencyLevelId]',
  '/video-player/[fileId]',
  '/course/[slug]/submissions/[id]/[learnerId]',
  '/stackable-course',
  '/reports/stackable',
  '/reports/stackable/[stackId]',
  '/stackable-course/[stackableId]',
  '/course/[slug]/question/ai-create',
];

export const ROUTE_PRELOGIN_LAYOUT = [
  '/homes/course',
  '/homes/course/[slug]',
  '/homes/intake/[slug]',
  '/homes/intake',
  '/homes/intake/intakeGridcard',
  '/homes/workshop',
  '/homes/workshop/view',
  '/login',
  '/loginCms',
  '/home',
  '/homeCms',
  '/homes/signup',
  '/homes/cart',
  '/homes/cart/wishList',
  '/homes/instructor',
  '/overview',
  '/homes/footer/aboutus',
  '/homes/footer/contactus',
  '/homes/footer/helpAndSupport',
  '/homes/footer/askus',
  '/homes/footer/overview',
  '/homes/footer/features',
  '/homes/footer/integration',
  '/homes/footer/privacypolicy',
  '/homes/footer/termsofservice',
  '/homes/footer/getstarted',
  '/homes/footer/mobileResponsive',
];
export const ROUTE_AUTH_LAYOUT = ['/login'];
